export default function isAbleToModifyBooking(testId, userId) {
    // Aksha , Vanshita , Darshan , Vishal
    let eliteUsers = ["6655d9b40777525410c88982", "651bd4c8ad7773279c5ae380", "6746d54f4d93e350eadae03f", "67b6eb62244cb99b99e46a9b"];
    if (eliteUsers.includes(userId)) {
        return true
    }
    if (testId == userId) {
        return true
    }
    return false;
}